import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]

import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'contactService',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const router = useRouter()
const props = __props
const goToNotifications = () => {
    router.push('/sd-message')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.itemData.url,
      alt: "",
      onClick: goToNotifications
    }, null, 8, _hoisted_2)
  ]))
}
}

})